import React, { FC, useState } from "react";
import BreadcrumbText from "../../../../components/components-text/breadcrumb-text";
import { TakerDataContainer } from "../../../hirings/new-hiring/gip/gip-taker/gip-taker-data-style";
import MainButton from "../../../../components/main-button";
import { images } from "../../../../assets";
import StepsMenu from "../../../../components/steps-menu/steps-menu";
import useForm from "../hooks/useForm";
import LeftInfoModal from "../../../../components/left-info-modal";
import { deepGet } from "../../../../utils/utility";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { NewInsuredContainer } from "../new-insured/newInsuredStepper-style";
import TakerStep from "../new-insured/taker/taker-step";
import RequiredDocumentsStep from "../new-insured/required-documents/required-documents-step";
import InputBox from "../../../../components/input-box/input-box";
import { getPolicyNumber } from "../utils";
import ProtectionData from "../components/protection-data/protection-data";
import { initialStepperPolicyHolderChangeData, validatePolicyHolderData } from "./utils";
import PolicyData from "../components/policy-data/policy-data";
import SupplementsServices from "../../../../services/SupplementsServices";
import { validateEmailByHocelot } from "../new-insured/utils";
import { MatchParams } from "../basic-data/basic-data.types";
import { SupplementsContext } from "../../../../context/supplements/SupplementsContext";

const stepsMenuProps = {
  policyData: {
    policyType: "", // ejemplo: Salud
    policyName: "", // ejemplo: Completa
    disabled: true,
  },
};

const buttonList = [
  { buttonText: "Datos del tomador", stepNumber: 1 },
  { buttonText: "Protección de datos", stepNumber: 2 },
  { buttonText: "Datos póliza y pago", stepNumber: 3 },
  { buttonText: "Documentación requerida", stepNumber: 4 },
];

const PolicyHolderChangeForm: FC<RouteComponentProps<MatchParams>> = ({ history }) => {
  const [steps, setSteps] = useState<number>(1);
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [confirmationModal, setConfirmationModal] = useState<boolean>(false);
  const [modal, setModal] = useState({ msg: "", status: false, type: "" });
  const [emailError, setEmailError] = useState("");
  const { values, errors, handleChange, setErrors } = useForm(
    initialStepperPolicyHolderChangeData(),
    () => validatePolicyHolderData(values, supplementsContext.supplementDocs),
    isFirstTime
  );
  const supplementsContext = React.useContext(SupplementsContext);

  const loggedMediatorString = localStorage.getItem("loggedMediator");
  const loggedMediator = loggedMediatorString ? JSON.parse(loggedMediatorString) : { mediatorCode: "" };

  const goToNextStep = async () => {
    const { errors, hasStepOneValidation, dataProtectioHasValidation, policyHasValidation } = validatePolicyHolderData(values, supplementsContext.supplementDocs);

    const errorEmail = await validateEmailByHocelot(deepGet(values, 'contact.email') || '')
    setEmailError(errorEmail);
    if (steps === 1 && hasStepOneValidation && !errorEmail) {
      setIsFirstTime(true);
      setSteps((previousValue) => previousValue + 1 );
      setErrors({});
    } else if (steps === 2 && dataProtectioHasValidation) {
      setSteps((previousValue) => previousValue + 1);
      setErrors({});
    } else if (steps === 3 && policyHasValidation) {
      setSteps((previousValue) => previousValue + 1);
      setErrors({});
    } else if (steps === 4) {
      setSteps((previousValue) => previousValue + 1);
      setErrors({});
    } else {
      setIsFirstTime(false);
      setErrors(errors);
    }
  };

  const goToPreviousStep = () => {
    steps === 1 && history.push(`/suplementos/${getPolicyNumber()}`);
    setErrors({});
    setSteps((previousValue) => previousValue - 1);
  };

  const sendForm = async () => {
    const response = await SupplementsServices.sendBasicDataModificationsEmail(values);

    if (response.data.status) {
      setModal({
        msg: "Los datos han sido enviado correctamente",
        status: true,
        type: "success",
      });
    } else {
      setModal({ msg: response.data.msg, status: true, type: "error" });
    }
  };

  const closeModal = () => {
    history.push(`/suplementos/${getPolicyNumber()}`);
  };

  const validateForm = () => {
    const { errors, documentsHasValidation } = validatePolicyHolderData(values, supplementsContext.supplementDocs);
    if (documentsHasValidation) {
      setConfirmationModal(true);
    } else {
      setErrors(errors);
    }
  };

  return (
    <NewInsuredContainer>
      <div className="subTitle">
        <BreadcrumbText>
          {"NUEVO SUPLEMENTO - CAMBIO DE TOMADOR"}
        </BreadcrumbText>
      </div>
      <div
        className="personal-data-row"
        style={{ width: "calc(100% - 290px)" }}
      >
        <div className="personal-data-item col-50">
          <div className="inputBox">
            <InputBox
              placeholder="Mediador"
              required={true}
              disabled={true}
              value={`${loggedMediator.mediatorCode} - ${loggedMediator.mediatorName} - ${loggedMediator.orderNif}`}
              onChange={() => {}}
              type={"letters"}
            />
          </div>
        </div>
        <div className="personal-data-item col-50">
          <div className="inputBox">
            <InputBox
              placeholder="Datos de Póliza a modificar"
              required={true}
              disabled={true}
              value={getPolicyNumber()}
              onChange={() => {}}
              type={"letters"}
            />
          </div>
        </div>
      </div>
      <div className="step-container">
        <div className="step">
          {steps === 1 && (
            <TakerStep
              values={values}
              errors={errors}
              handleChange={handleChange}
              customError={emailError}
              setCustomError={setEmailError}
              title="DATOS DEL TOMADOR"
            />
          )}
          {steps === 2 && (
            <>
              <div className="data-flow-status">
                <div className="data-flow-status-title">
                  <h2>PROTECCIÓN DE DATOS</h2>
                </div>
              </div>
              <ProtectionData
                values={values}
                errors={errors}
                handleChange={handleChange}
              />
            </>
          )}
          {steps === 3 && (
            <>
              <div className="data-flow-status">
                <div className="data-flow-status-title">
                  <h2>DATOS DE PÓLIZA Y PAGO</h2>
                </div>
              </div>
              <PolicyData
                values={values}
                errors={errors}
                handleChange={handleChange}
              />
            </>
          )}
          {steps === 4 && (
            <RequiredDocumentsStep
              values={values}
              errors={errors && errors.documents ? errors.documents : {}}
              handleChange={handleChange}
              hideInsurance
              setErrors={setErrors}
            />
          )}
        </div>
      </div>
      <StepsMenu
        policyData={stepsMenuProps.policyData}
        buttonFunction={setSteps}
        actualStep={steps}
        buttonList={buttonList}
      />

      <TakerDataContainer>
        <div className="colSin-100 topMargin20 bottomMargin20">
          <div className="personal-data-buttons">
            <div className="personal-data-buttons__item">
              <MainButton
                withTab={true}
                icon={true}
                type={"white"}
                iconImg={images.IconArrowLeftBlue}
                text="Atrás"
                onClick={goToPreviousStep}
              />
            </div>
            {steps === 4 ? (
              <div className="personal-data-buttons__item">
                <MainButton
                  withTab={true}
                  text="Enviar"
                  onClick={validateForm}
                />
              </div>
            ) : (
              <div className="personal-data-buttons__item">
                <MainButton
                  withTab={true}
                  text="Siguiente"
                  onClick={goToNextStep}
                />
              </div>
            )}
          </div>
        </div>
      </TakerDataContainer>

      <LeftInfoModal
        img={
          modal.type === "error" ? images.WarningError : images.IconCheckGreen2
        }
        mainTitle={modal.type === "error" ? "Error" : "Aviso"}
        mainText={modal.msg}
        noSecondaryButton={true}
        buttonText="Continuar"
        active={modal.status}
        onClickAccept={closeModal}
        close={() => setModal({ msg: "", status: false, type: "" })}
        className={modal.type === "error" ? "error" : "info"}
      />
      <LeftInfoModal
        img={images.IconCheckGreen2}
        mainTitle={"Aviso"}
        mainText={"Se va a enviar una solicitud de suplemento para cambio de tomador"}
        secondaryText={"¿Desea Continuar?"}
        noSecondaryButton={false}
        buttonText={"Si"}
        closeButtonText={"NO"}
        active={confirmationModal}
        onClickAccept={sendForm}
        close={() => setConfirmationModal(false)}
        className={"info"}
      />
    </NewInsuredContainer>
  );
};

export default withRouter(PolicyHolderChangeForm);
